import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { styles } from "./styles";
import AddCampaign from "./addCampaign";
import ListCampaign from "./listCampaign";
import Header from "../../partials/header";

// Component
class Campaign extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isAddCampaign: false,
    };
    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {}

  addNewCampaign = () => {
    this.setState({ isAddCampaign: !this.state.isAddCampaign });
  };
  handleSearch(event) {
    if (event.target.value === "")
      this.props.getList({
        limit: this.mListCampaign.state.rowsPerPage,
        page: this.mListCampaign.state.page,
      });
    else this.props.getList({ search: event.target.value });
  }
  render() {
    const { t } = this.props;

    return (
      <div>
        {!this.state.isAddCampaign ? (
          <Header
            session={t("sidebar_cms")}
            title={t("campaign_list_campaign")}
            button={t("campaign_add_campaign")}
            actionButton={this.addNewCampaign}
          />
        ) : (
          <Header
            session={t("campaign_list_campaign")}
            title={t("campaign_add_campaign")}
            backIcon={true}
            actionBack={() => this.addNewCampaign()}
          />
        )}
        {!this.state.isAddCampaign ? (
          <ListCampaign onRef={(list) => (this.mListCampaign = list)} />
        ) : (
          <AddCampaign createDone={this.addNewCampaign} />
        )}
      </div>
    );
  }
}

Campaign.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({
  getVoucher: dispatch.voucher.getVoucher,
  getList: dispatch.campaigns.getList,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: true })(Campaign)));
